const Print = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M8.99805 17.0025H15.0018" stroke="currentColor" />
    <path d="M8.99805 15.0012H15.0018" stroke="currentColor" />
    <path
      d="M7.66354 15.0019H5.66229C4.92636 14.9997 4.33032 14.4036 4.32812 13.6677V9.66522C4.33032 8.92929 4.92636 8.33325 5.66229 8.33105H18.3369C19.0728 8.33325 19.6688 8.92929 19.671 9.66522V13.6677C19.6688 14.4036 19.0728 14.9997 18.3369 15.0019H16.3356"
      stroke="currentColor"
    />
    <path
      d="M7.66406 6.99689V4.32855H14.0587C14.2356 4.32859 14.4053 4.3989 14.5304 4.52401L16.1407 6.13435C16.2658 6.25942 16.3361 6.42907 16.3361 6.60597V6.99689"
      stroke="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.3361 19.0044C16.3361 19.3728 16.0375 19.6715 15.6691 19.6715H8.33115C7.96273 19.6715 7.66406 19.3728 7.66406 19.0044V13.0006H16.3361V19.0044Z"
      stroke="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.32919 10.9987C6.69761 10.9987 6.99628 10.7001 6.99628 10.3316C6.99628 9.96321 6.69761 9.66455 6.32919 9.66455C5.96077 9.66455 5.66211 9.96321 5.66211 10.3316C5.66211 10.7001 5.96077 10.9987 6.32919 10.9987Z"
      stroke="currentColor"
    />
    <path d="M13.668 4.32788V6.99621H16.3363" stroke="currentColor" />
  </svg>
)

export default Print
